import React, { useState, useEffect, useContext, Component } from 'react';
import { useNavigate, Link, useParams } from "react-router-dom";
import { Helmet } from "react-helmet";
import axios from 'axios';
import { useDispatch } from 'react-redux';
import { authActions } from '../../../redux/store';
import { toast } from 'react-hot-toast';
import Header from '../../components/Header';
import Footer from '../../components/Footer';
import axiosInstance from '../../../axiosInstance';
import getDecryptData from '../../../helper/getDecryptData';
import { useBlogContext } from '../../../fetchdata/BlogContext';

const SuccessPage = () => {
  const { id } = useParams();

  const [enquireData, setEnquireData] = useState([

  ]);

  const {
    Headers,

  } = useBlogContext();

  const [EnquireShow, setEnquireShow] = useState(false);
  
  const [NotiShow, setNotiShow] = useState(false);


    const [EnquireStatus, setEnquireStatus] = useState(false);
  
    const enquireToggle = () => {
      if (EnquireShow) {
        setEnquireShow(false);
      } else {
        setEnquireShow(true);
      }
    };
  
    const capitalizeEachWord = (str) => {
      if (!str) return str;
      str = str.replace(/\d+/g, "");
      return str
        .split(" ")
        .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
        .join(" ");
    };
  
    const validate = (email) => {
      // Regular expression to check for invalid characters
      const invalidCharsRegex = /[^\w@_.]| /; // Disallow spaces and any character that's not a word character, @, or .
  
      // Check for invalid cases
      if (email === "-" || email === "+") {
        return "";
      } else if (invalidCharsRegex.test(email)) {
        return ""; // Return empty string if invalid characters (including spaces) are found
      } else {
        return email; // Return the original email if valid
      }
    };
  
    const handleEnquireChange = (e) => {
      const { name, value, type, checked } = e.target;
  
      // Determine the new value based on input type
      let newValue;
      if (type === "checkbox") {
        newValue = checked;
      } else {
        newValue = value;
      }
  
      // Capitalize each word for specific fields
      if (name === "fullname") {
        newValue = capitalizeEachWord(newValue);
      }
  
      if (name === "email") {
        newValue = validate(newValue);
      }
  
      if (name === "phone") {
        // Replace non-digit characters
        newValue = value.replace(/\D/g, ""); // This allows only digits
        if (newValue.length > 13) {
          newValue = newValue.slice(0, 13); // Limit to 10 digits
        }
      }
  
      // Update form data with the new value
      setEnquireData((prevData) => ({
        ...prevData,
        [name]: newValue,
      }));
    };
  
    const handleSendEnquire = async () => {
      const fields = [
        { name: "fullname", message: "Please enter Full Name" },
        { name: "phone", message: "Please enter phone number" },
        { name: "email", message: "Please enter email" },
        { name: "requirement", message: "Please enter Quantity" },
      ];
  
      for (const field of fields) {
        if (!enquireData[field.name]) {
          toast.error(field.message);
          setEnquireStatus(false);
          return;
        }
      }
  
      try {
        setEnquireStatus(true);
        await toast.promise(axiosInstance.post(`/send-enquire-consultation`, enquireData), {
          loading: "Enquire Submiting...", // Loading message
          success: "Enquire Submited Successfully!", // Success message
          error: "Failed to Submit Enquire.", // Error message
        });
        enquireToggle();
        setEnquireData((prevData) => ({
          ...prevData,
          fullname: "",
          email: "",
          phone: "",
          service: "",
        
        })); // Clear form fields
        setNotiShow(true)
      } catch (error) {
        console.error("Failed to send email:", error);
        // toast.error('Failed to send email');
      } finally {
        setEnquireStatus(false);
        
      }
    };
  
    const getData = async () => {

      const decryptdatajson = await getDecryptData();
     
         const id = decryptdatajson?._id;
         const username = decryptdatajson?.username
         const email = decryptdatajson?.email;
         const phone = decryptdatajson?.phone;
 
        // Update form data with the new value
        setEnquireData((prevData) => ({
         ...prevData,
         fullname:username,
         email,
         phone
       }));
     }
 
    
  useEffect(() => {
      

    getData();

  }, []);

  
      
  return (
    <>
     

      <div
        className="modal enquire fade show"
        style={{ display: EnquireShow ? "block" : "none" }}
        id="exampleModal"
        tabIndex={-1}
        role="dialog"
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-dialog-centered" role="document">
          <div className="modal-content">
            <div className="modal-header py-0">
              <h5 className="modal-title" id="exampleModalLabel">
              Free Consultation with a Doctor
              </h5>
              <button
                type="button"
                className="border-0 close bg-transparent h3"
                data-dismiss="modal"
                aria-label="Close"
                onClick={enquireToggle}
              >
                <span aria-hidden="true">×</span>
              </button>
            </div>
            <div className="modal-body">
              <div className="d-block">
                {/* Name input */}
                <div data-mdb-input-init="" className="form-outline mb-4">
                  <label className="form-label" htmlFor="form5Example1">
                    Full Name <span className="text-danger"> (Required )</span>
                  </label>
                  <input
                    type="text"
                    name="fullname"
                    id="form5Example1"
                    className="form-control"
                    value={enquireData.fullname}
                    onChange={handleEnquireChange}
                    style={{ boxShadow: "none" }}
                  />
                </div>
                {/* Email input */}
                <div data-mdb-input-init="" className="form-outline mb-4">
                  <label className="form-label" htmlFor="form5Example2">
                    Phone No. <span className="text-danger"> (Required )</span>
                  </label>
                  <input
                    type="number"
                    id="form5Example2"
                    className="form-control"
                    name="phone"
                    value={enquireData.phone}
                    onChange={handleEnquireChange}
                    style={{ boxShadow: "none" }}
                  />
                </div>

                <div data-mdb-input-init="" className="form-outline mb-4">
                  <label className="form-label" htmlFor="form5Example2">
                    Email address{" "}
                    <span className="text-danger"> (Required )</span>
                  </label>
                  <input
                    type="email"
                    id="form5Example2"
                    className="form-control"
                    name="email"
                    value={enquireData.email}
                    onChange={handleEnquireChange}
                    style={{ boxShadow: "none" }}
                  />
                </div>

                <div data-mdb-input-init="" className="form-outline mb-4">
                  <label className="form-label" htmlFor="form5Example2">
                    Requirement{" "}
                    <span className="text-danger"> (Required )</span>
                  </label>
                  <textarea
                    type="text"
                    id="requirement"
                    className="form-control"
                    name="requirement"
                    value={enquireData.requirement}
                    onChange={handleEnquireChange}
                    style={{ boxShadow: "none" }}
                  />
                  <input
                    type="text"
                    id="service"
                    value={'Product?.title'}
                    className="form-control d-none"
                    style={{ boxShadow: "none" }}
                  />
                </div>
              </div>
            </div>
            <div className="modal-footer">
              <button
                type="button"
                className="btn btn-secondary"
                data-dismiss="modal"
                onClick={enquireToggle}
              >
                Close
              </button>
              <button
                type="button"
                className="btn btn-primary"
                onClick={handleSendEnquire}
                disabled={EnquireStatus} // Properly use the `disabled` attribute
              >
                Submit
              </button>
            </div>
          </div>
        </div>
      </div>


   <div className="container">
        <div className="d-flex gap-4 justify-content-between p-4 align-items-center">
          {/* Logo */}
          <Link
            className="navbar-brand flex-shrink-0 flex-fill "
            to="/"
            style={{ borderRadius: 5, aspectRatio: "120/25", height: 40 }}
          >
            {Headers.meta_logo && Headers.meta_logo !== undefined ? (
              <img
                src={Headers.meta_logo}
                width={120}
                alt="logo"
                style={{
                  maxHeight: 50,
                  width: "auto",
                  filter: "grayscale(0)",
                  mixBlendMode: "multiply",
                }}
              />
            ) : (
              <div
                className="card-1 skeleton"
                style={{
                  borderRadius: 5,
                  aspectRatio: "142/25",
                  width: "100%",
                  height: 50,
                }}
              ></div>
            )}
          </Link>
          <Link className="btn btn-dark btn-md rounded-xl" to={'/'} >
            <i class="ri-arrow-left-circle-line text-white"></i> Back</Link>

        </div>
      </div>


      <main className="page ">

        <div
          className="bg-light w-100 p-4 d-flex align-items-center"
          style={{ height: "85vh" }}
        >
          
          <div className="user-form   mx-auto" style={{ maxWidth: 400 }}>
            <div className="card  border bg-white shadow  m-0 rounded-sm-0 overflow-hidden">
              <div className="body px-4 text-center">

                <p class="fw- mt-3 text-start">As you are a memeber of our healthcard 
                get free doctor consultation </p>

{NotiShow && 
<p className='bg-success p-2 text-white'>We have received your appointment request and will connect with you shortly.</p>
}
            
              <button
              
              className="btn btn-primary fw-light w-100 d-flex mt-3"
            
              type="button"
              data-toggle="modal"
              data-target="#exampleModal"
              onClick={enquireToggle}
            >
             
              <span className="col"> Consult To Doctor Free </span>
               <i className="ri-stethoscope-line ms-1"></i>
            </button>

                <img
                  src="/assets/img/success.gif" className="w-100 mx-auto d-block"
                  style={{ maxWidth: 150 }} />
                <h4 className="text-success"> Payment Success !!</h4>
                <p>Order Id : {id}</p>
                <div className="d-flex gap-4 pb-3">
                <Link
                    to="/account/all-transactions"
                    className="btn btn-dark fw-light w-100 d-flex"
                    type="button"
                  >
                    <span className="col"> Invoice </span>
                    <i className="ri-arrow-right-s-line ms-auto" />
                  </Link>

                 
                 
                </div>

         

              </div>
            </div>
          </div>
        </div>

      </main>

 
    </>

  );
};

export default SuccessPage